import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "4565c5e1-1bc4-4264-a6da-2db4ded2368d",
    content: "Listening tests are commonly employed in the<br>development process of lossy codecs",
    options: {},
  },
  {
    id: "371bdb5e-2b54-4d32-b582-4ee64756edf7",
    content: "Sound quality evaluation for systems with a known<br>reference relies solely on objective metrics",
    options: {},
  },
  {
    id: "f67418d4-80ce-45ea-8a8e-a33273d4e0f0",
    content: "Uncompressed PCM audio serves as the reference for<br>subjective evaluation of the coded output",
    options: {},
  },
  {
    id: "e93b151d-1cba-481b-91da-c844c506772e",
    content: "Listening tests are conducted exclusively in a formal<br>manner, following defined testing protocols",
    options: {},
  },
];

export const task: Task = {
  id: "5f133355-83d5-4e68-ad63-9e66740abf68",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4565c5e1-1bc4-4264-a6da-2db4ded2368d", "f67418d4-80ce-45ea-8a8e-a33273d4e0f0"],
};
